<template>
  <div class="data-table-footer">
    <div class="data-table-footer-info">
      Showing {{ startItem }} - {{ endItem }} of {{ totalItems }} items
    </div>
    
    <div class="d-flex align-center">
      <div class="data-table-per-page">
        <span>Rows per page:</span>
        <v-select
          v-model="localItemsPerPage"
          :items="itemsPerPageOptions"
          variant="plain"
          density="compact"
          hide-details
          class="pagination-select"
          @update:model-value="$emit('update:items-per-page', $event)"
        ></v-select>
      </div>
      
      <v-pagination
        v-if="totalItems > 0"
        v-model="localPage"
        :length="Math.ceil(totalItems / localItemsPerPage)"
        :total-visible="7"
        density="comfortable"
        @update:model-value="$emit('update:page', $event)"
      ></v-pagination>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';

const props = defineProps({
  page: {
    type: Number,
    default: 1
  },
  itemsPerPage: {
    type: Number,
    default: 10
  },
  totalItems: {
    type: Number,
    default: 0
  },
  itemsPerPageOptions: {
    type: Array,
    default: () => [10, 25, 50, 100]
  }
});

const emit = defineEmits(['update:page', 'update:items-per-page']);

const localPage = ref(props.page);
const localItemsPerPage = ref(props.itemsPerPage);

// Keep local values in sync with props
watch(() => props.page, (val) => {
  localPage.value = val;
});

watch(() => props.itemsPerPage, (val) => {
  localItemsPerPage.value = val;
});

// Calculate start and end items
const startItem = computed(() => {
  if (props.totalItems === 0) return 0;
  return (props.page - 1) * props.itemsPerPage + 1;
});

const endItem = computed(() => {
  return Math.min(props.page * props.itemsPerPage, props.totalItems);
});
</script> 